import { Component, ComponentRef, Input, ViewChild, ViewContainerRef } from '@angular/core';
import { DynamicFormComponent } from '../../../../../dynamic-form/dynamic-form.component';
import { CommonModule } from '@angular/common';
import { AccordionTableComponent } from '../../../../../accordion-table/accordion-table.component';
import { ConfirmDialogV2Component } from '../../../../../confirm-dialog/confirm-dialog-v2.component';
import { FormGroup } from '@angular/forms';
import { DynamicForm } from '../../../../../../models/dynamic-form';
import { JobOrderFormActions } from '../../job-order-renderer/job-order-renderer.component';
import { DynamicFormService } from '../../../../../../services/dynamic-form.service';
import { convertEpochToISTDateTime } from '../../../../../../utils/date-time-utils';
import { MultiSelectComponent } from '../../../../../select/multi-select.component';
import { OperationService } from '../../../../../../services/operations.service';
import { InventoryService } from '../../../../../../services/inventory-service';
import { LoadingService } from '../../../../../../services/loading.service';
import { ToasterService } from '../../../../../../services/toaster.service';
import { AutocompleteDropdownComponent } from '../../../../../autocomplete-dropdown/autocomplete-dropdown.component';
import { SharedModule } from '../../../../../../modules/shared/shared.module';
import { SvgIconComponent } from '../../../../../svg-icon/svg-icon.component';
import {InventoryDetails, JobOrderAdditionalInfo, JobOrderInventory, JobOrderVendorService, JOInventoryAdditionalInfo } from '../../../../../../models/job-orders.interface';
import { InventoryType, PageAction } from '../../../../../../constants/app-constants';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize, firstValueFrom, forkJoin, Observable, of, Subject, switchMap, throwError } from 'rxjs';
import { CommonUtils } from '../../../../../../utils/common-utils';
import { JobOrderService, joinCompositeKey } from '../../../../../../services/job.order.service';
import { ServiceType } from '../../../../../../constants/master-constants';
import { HttpClient } from '@angular/common/http';
import { EditableTableMeta } from '../../../../../../models/editable-table-header.interface';
import { EditableTableComponent } from '../../../../../editable-table-v2/editable-table.component';
import { SectionHeaderComponent } from '../../../../../common/section-header/section-header.component';
import { JOShippingBill, ShippingBill } from '../../../../../../models/shipping-bill.interface';
import { RightPanelComponent } from '../../../../../right-panel/right-panel.component';
import { ManageInventoryServiceComponent } from '../../common/manage-inventory-service/manage-inventory-service.component';
import { VendorAccordionContentComponent } from '../../../vendor-accordion-content/vendor-accordion-content.component';
import { JobOrderDetails } from '../../../../../../models/job-order-details.interface';
import { APIResponse } from '../../../../../../models/standard-response.interface';
import { CargoService } from '../../../../../../services/inventory/cargo.service';
import { CargoItem } from '../../../../../../models/cargo-item.interface';
import { EditableGridFormComponent } from '../../../../../editable-grid-form/editable-grid-form.component';
import { DataUpdatedOutput } from '../../../../../editable-table-v2/DataUpdatedOutput.interface';


@Component({
  selector: 'app-carting',
  standalone: true,
  imports: [DynamicFormComponent,
      CommonModule,
      AccordionTableComponent,
      ConfirmDialogV2Component,
      MultiSelectComponent,
      AutocompleteDropdownComponent,
      EditableTableComponent,
      SectionHeaderComponent,
      SvgIconComponent,
      SharedModule],
  templateUrl: './carting.component.html',
  styleUrl: './carting.component.scss',
})
export class CartingComponent implements JobOrderFormActions {
  @Input() processCycle!: string;
  @Input() jobOrderType!: string;
  @Input() jobOrderId!: string;
  @Input() jobOrderConfig!: any;

  jobOrderForm!: FormGroup;
  dynamicForm!: DynamicForm;
  
  mode = PageAction.INSERT;

  itemList: JOShippingBill[] = [];
  selectedItem: any = null;
  searchText: string = '';
  disableAddButton: boolean = true;
  itemCache: Map<string, ShippingBill> = new Map();


  cargoTableMeta!: EditableTableMeta;


  private vendorMap: Map<string, JobOrderVendorService[]> = new Map();
  private loadPlanMap: Map<string, InventoryDetails[]> = new Map();
  private initialInventoryMap: Map<string, string> = new Map();
  private initialVendorIds: Set<string> = new Set();

  @ViewChild(EditableTableComponent) editableTableComponent!: EditableTableComponent;

  constructor(private dynamicFormSerice: DynamicFormService,
    private inventoryService: InventoryService,
    private loadingService: LoadingService,
    private toasterService: ToasterService,
    private viewContainerRef: ViewContainerRef,
    private operationService: OperationService,
    private jobOrderService: JobOrderService,
    private cargoService: CargoService,
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient
  ) {
    this.jobOrderForm = new FormGroup({});
  }

  ngOnInit() {
    this.dynamicForm = this.jobOrderConfig.jobOrderFormElements;
    this.dynamicFormSerice.addControlsToForm(this.jobOrderForm, this.dynamicForm);
    this.setComponentMode();
    this.loadJobOrderData(this.jobOrderId);
  }

  setComponentMode() {
    if (this.jobOrderId === "") {
      this.setDefaultValues();
      return;
    }

    if (this.route.snapshot.url[0].path === "edit") {
      this.mode = PageAction.UPDATE;
    } else {
      this.mode = PageAction.VIEW;
    }
  }

  get isViewMode() : boolean {
    return this.mode == PageAction.VIEW;
  }

  setDefaultValues() {
    this.jobOrderForm.get("issueDate")?.setValue(convertEpochToISTDateTime(new Date().getTime()));
  }

  onItemSelected(cargo: any) {
    this.selectedItem = cargo;
    this.disableAddButton = false;
  }

  handleInlineAction(event: { actionName: string, index: number }) {
    if (event.actionName === "manage-service") {
      this.manageServices(event.index);
    }
  }

  configureServices() {
    const inventoryOptions = this.itemList
    .filter(item => {
      if (!item.truckNo || !item.truckNo.trim()) {
        this.toasterService.error(`Truck number is missing for shipping bill ${item.documentNo}`);
        return false;
      }
      return true;
    })
    .map((item: JOShippingBill) => ({
      key: joinCompositeKey([item.id!, item.truckNo!]),
      value: `${item.documentNo} (Truck: ${item.truckNo})`
    }));

  if (inventoryOptions.length === 0) {
    this.toasterService.error("No valid shipping bills with truck numbers available to configure services.");
    return;
  }
    this.jobOrderService.openServicePanel(
      this.viewContainerRef,
      inventoryOptions,
      InventoryType.CARGO,
      ServiceType.GENERAL_SERVICE,
      null,
      (service, ids) => {
        this.jobOrderService.addServiceToCompositeInventory(this.vendorMap, this.itemList, service, ids, InventoryType.CARGO);
      }
    );
  }

  manageServices(index: number) {
    const rightPanelComponentRef = this.viewContainerRef.createComponent(RightPanelComponent);
    rightPanelComponentRef.instance.title = "Manage Service";
    rightPanelComponentRef.instance.hidePrimaryButton = true;
    rightPanelComponentRef.instance.showActionBtns = true;
    rightPanelComponentRef.instance.secondaryActionBtnText = "Close";
    
    const shippingBill = this.itemList[index];
    const compositeKey = this.getCompositeKey(shippingBill);
    if (!this.vendorMap.has(compositeKey)) {
      this.vendorMap.set(compositeKey, []);
    }

    const manageAttributeRef = rightPanelComponentRef.instance.loadComponent(ManageInventoryServiceComponent);
    manageAttributeRef.setInput("serviceList", this.vendorMap.get(compositeKey));
    manageAttributeRef.setInput("inventoryType", InventoryType.CARGO);
    manageAttributeRef.setInput("parentViewContainerRef", this.viewContainerRef);
    manageAttributeRef.setInput("readonly", this.isViewMode);

    console.log("this.isViewMode => ", this.isViewMode);

    rightPanelComponentRef.instance.close.subscribe(() => {
      manageAttributeRef.instance.publishUpdatedList();
    })

    manageAttributeRef.instance.serviceListListener.subscribe((jobOrderVendorService: JobOrderVendorService[]) => {
      this.vendorMap.set(compositeKey, jobOrderVendorService);
      rightPanelComponentRef.destroy();
    });
  }
  
  loadJobOrderData(jobOrderId: string) {
    if (this.mode === PageAction.INSERT) return;
    this.loadingService.show();
      this.operationService.getJobOrderByIdLite(jobOrderId).pipe(
        switchMap((response: any) => {
          const jobOrderData = response?.data as JobOrderDetails;
    
          const cargoInventories = jobOrderData.jobOrderInventoryList
            .filter((inv: any) => inv.inventoryType === "CARGO");

          const cargoIds = Array.from(new Set(cargoInventories.map(inv => inv.inventoryId)));
          
          const forkJoinPayload: {
            jobOrder: Observable<any>,
            cargoResponse?: Observable<any>
          } = {
            jobOrder: of(jobOrderData)
          };

          if (cargoIds.length) {
            forkJoinPayload.cargoResponse = this.inventoryService.listShippingBill(CommonUtils.buildIdFilterRequest(cargoIds));
          }
  
          return forkJoin(forkJoinPayload);
        }),
        finalize(() => this.loadingService.hide())
      ).subscribe({
        next: (result: { jobOrder: JobOrderDetails; cargoResponse?: APIResponse }) => {
          const cargos = result.cargoResponse?.data?.records ?? [];
          this.hydrateForm(result.jobOrder, cargos);
        },
        error: (error) => {
          console.error(error);
          this.toasterService.error("Failed to get job order data");
        }
      });
  }


  async hydrateForm(jobOrderData: JobOrderDetails, cargos: CargoItem[]) {
    cargos.forEach(cargo => {
      if (cargo.id) {
        const sb = this.cargoService.transformToShippingBill(cargo);
        this.itemCache.set(cargo.id, sb);
      }
    });

    for (const [index, inventory] of jobOrderData.jobOrderInventoryList.entries()) {
      const inventoryId = inventory.inventoryId;    
      const associatedItems = inventory.additionalDetails?.associatedItems ?? [];
      const cachedShippingBill = this.itemCache.get(inventoryId);
      await this.addItem(cachedShippingBill);
      const joShippingBill = this.itemList[index];
      
      if (associatedItems.length > 0) {
        const firstItem = associatedItems[0];
        const joShippingBill = this.itemList[index];
        joShippingBill.truckNo   = firstItem.inventoryNo;
        joShippingBill.joNop     = firstItem.nop ?? 0;
        joShippingBill.joWeight  = firstItem.weight ?? 0;
        joShippingBill.joVolume  = firstItem.volume ?? 0;
      }

      const compositeKey = this.getCompositeKey(joShippingBill);
      this.initialInventoryMap.set(compositeKey, inventory.joInvId!);
  
      // Handle vendor services
      if (Array.isArray(inventory.jobOrderServiceList) && inventory.jobOrderServiceList.length) {
        this.vendorMap.set(compositeKey, inventory.jobOrderServiceList);
        inventory.jobOrderServiceList.forEach(service => {
          if (service.id) {
            this.initialVendorIds.add(service.id);
          }
        });
      }
    }

    this.jobOrderForm.patchValue({
      ...jobOrderData,
      ...jobOrderData?.additionalDetails,
      warehouse: {key: jobOrderData.additionalDetails?.warehouse?.id, value: jobOrderData.additionalDetails?.warehouse?.name},
      expiryDate: convertEpochToISTDateTime(jobOrderData?.expiryDate),
      issueDate: convertEpochToISTDateTime(jobOrderData?.issueDate)
    });

    if (this.isViewMode) {
      this.jobOrderForm.disable();
    }
  }

  saveForm(): void{
    this.jobOrderForm.markAllAsTouched();
    if (!this.validateTrucksAndShippingBill(this.itemList)) return;
    
    const jobOrderRequest = this.createJobOrderRequest();
    const jobOrder$ = this.mode == PageAction.UPDATE
                      ? this.operationService.updateJobOrder(this.jobOrderId, jobOrderRequest)
                      : this.operationService.saveJobOrder(jobOrderRequest);

    jobOrder$.subscribe({
      next: (response) => {
        this.toasterService.success("Successfully " + this.mode == PageAction.UPDATE ? "updated" : "created" + " the job order");
        this.goBack();
      },
      error: (error) => {
        console.log("Request failed:", error);
        this.toasterService.error(error.error.errorDesc);
      }
    });
  }

  createJobOrderRequest(): any {
    const jobOrderInventoryList: JobOrderInventory[] = this.createJobOrderInventory();
    const deletedJobOrderVendorIds = this.getDeletedVendorIds();
    const jobOrderAdditionalInfo: JobOrderAdditionalInfo = {
      warehouse: CommonUtils.toIDName(this.jobOrderForm.get("warehouse")?.value)
    }

    return {
      jobOrderType: this.jobOrderType,
      jobOrderAdditionalInfo,
      operationalProcess: this.processCycle,
      expiryDate: new Date(this.jobOrderForm.get("expiryDate")?.value).getTime(),
      jobOrderInventoryList,
      deletedJobOrderVendorIds
    };
  }

  createJobOrderInventory(): JobOrderInventory[] {
    const itemInventories = (this.itemList ?? []).map((cargo: JOShippingBill, index) => ({
      joInvId: this.initialInventoryMap.get(this.getCompositeKey(cargo)),
      inventoryId: cargo.id!,
      inventoryNo: cargo.documentNo,
      inventoryType: 'CARGO',
      jobOrderServiceList: this.vendorMap.get(this.getCompositeKey(cargo)),
      vehicleInfo: {
        inventoryNo: cargo.truckNo!,
        nop: cargo.joNop,
        weight: cargo.joWeight,
        volume: cargo.joVolume,
      }
    }));
    return itemInventories;
  }

  getDeletedVendorIds(): string[] {
    const currentVendorIds = new Set<string>();
    this.vendorMap.forEach((vendors) => {
      vendors.forEach((vendor: JobOrderVendorService) => {
        if (vendor.id) {
          currentVendorIds.add(vendor.id);
        }
      });
    });

    const deletedVendorIds: string[] = [];
    this.initialVendorIds.forEach((jovId) => {
      if (!currentVendorIds.has(jovId)) {
        deletedVendorIds.push(jovId);
      }
    });

    return deletedVendorIds;
  }

  cancel(): void {
    this.goBack();
  }

  goBack(): void {
    this.router.navigateByUrl("/manage-operations/import/job-orders");
  }

  async addItem(cargoItem?: ShippingBill) {
    const itemId = cargoItem?.id ?? this.selectedItem.id
    if (!this.selectedItem && !cargoItem) {
      this.resetSelection();
      return;
    }
  
    this.loadingService.show();
  
    try {
      let shippingBill: JOShippingBill;
  
      if (this.itemCache.has(itemId)) {
        shippingBill = structuredClone(this.itemCache.get(itemId)!);
      } else {
        const response = await firstValueFrom(this.inventoryService.fetchShippingBillById(itemId));
        const fetchedBill = response.data as JOShippingBill;

        this.itemCache.set(itemId, fetchedBill);
          shippingBill = structuredClone(fetchedBill);
      }
  
      this.itemList.push(shippingBill);
    } catch (err) {
      console.error('Error fetching item details:', err);
      this.toasterService.error('Failed to fetch item details');
    } finally {
      this.resetSelection();
      this.loadingService.hide();
    }
  }

  private resetSelection(): void {
    this.searchText = '';
    this.disableAddButton = true;
    this.selectedItem = null;
  }

  private validateTrucksAndShippingBill(joShippingBillList: JOShippingBill[]): boolean {
    const assignedPackageSummary = new Map<string, { nop: number; weight: number; volume: number }>();

    for (const cargoItem of joShippingBillList) {      
      if (!cargoItem?.truckNo || !cargoItem.truckNo.trim()) {
        this.toasterService.error(`Truck No is required for Shipping Bill ${cargoItem?.documentNo}`);
        return false;
      }

      if (!cargoItem.joNop || cargoItem.joNop <= 0) {
        this.toasterService.error(`Invalid number of packages for truck ${cargoItem.truckNo} and shipping bill ${cargoItem.documentNo}`);
        return false;
      }

      const compositeKey = this.getCompositeKey(cargoItem);
      const vendorList = this.vendorMap.get(compositeKey);
      if (!vendorList || vendorList.length === 0) {
        this.toasterService.error(`Services are not configured for truck ${cargoItem.truckNo} and shipping bill ${cargoItem.documentNo}`);
        return false;
      }

      const existing = assignedPackageSummary.get(cargoItem.id!) ?? { nop: 0, weight: 0, volume: 0 };
      assignedPackageSummary.set(cargoItem.id!, {
        nop: existing.nop + cargoItem.joNop,
        weight: existing.weight + (cargoItem.joWeight ?? 0),
        volume: existing.volume + (cargoItem.joVolume ?? 0)
      });
    }

    for (const [cargoId, pkg] of assignedPackageSummary.entries()) {
      const cargoItem = this.itemCache.get(cargoId);
      if (!cargoItem) continue;
  
      if (pkg.nop > (cargoItem.nop ?? 0)) {
        this.toasterService.error(`Total assigned packages (${pkg.nop}) exceed registered NOP (${cargoItem.nop}) for ${cargoItem.documentNo}`);
        return false;
      }
  
      if (pkg.weight > (cargoItem.weight ?? 0)) {
        this.toasterService.error(`Total assigned weight (${pkg.weight}) exceed registered weight (${cargoItem.weight}) for ${cargoItem.documentNo}`);
        return false;
      }
  
      if (pkg.volume > (cargoItem.volume ?? 0)) {
        this.toasterService.error(`Total assigned volume (${pkg.volume}) exceed registered volume (${cargoItem.volume}) for ${cargoItem.documentNo}`);
        return false;
      }
    }
    return true;
  }

  private getCompositeKey(shippingBill: JOShippingBill) {
    if (!shippingBill.truckNo || !shippingBill.truckNo.trim()) {
      this.toasterService.error(`Truck number is missing for shipping bill ${shippingBill.documentNo}`);
      return '';
    }
    return joinCompositeKey([shippingBill.id!, shippingBill.truckNo]);
  }
  
}